import { createDefaultVendorOrdersData, IVendorOrdersData } from '../../../types/vendorDashboard/IVendorOrders';
import {
  createDefaultSearchOrdersSettingsData,
  ISearchOrdersSettingsData,
} from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';

export interface IVendorOrdersState {
  orders: IVendorOrdersData;
  searchSettings: ISearchOrdersSettingsData;
  ordersFetchStatus: IFetchStatus;
  ordersError?: string;
}

export const vendorOrdersInitialState: IVendorOrdersState = {
  orders: createDefaultVendorOrdersData(),
  searchSettings: createDefaultSearchOrdersSettingsData(),
  ordersFetchStatus: createDefaultFetch(),
};
